
// Core
import React, { lazy, useEffect, useState } from 'react';
import {
    Card, Row, Col, Table, Spin, Tooltip, Select, notification, Form, Input, Button
} from 'antd';
import { useHistory } from 'react-router-dom';
import FontAwesome from 'react-fontawesome';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import FeatherIcon from 'feather-icons-react';
import Moment from 'moment';
import 'moment/locale/es-mx';
import { SearchOutlined } from '@ant-design/icons';

// App
import {
    pacientePagoCompraAction
} from '../../../redux/clinica/pacientes/actionCreator';
import { Cards } from '../../../components/cards/frame/cards-frame';
import { TableWrapper } from '../../styled';
import { PageHeader } from '../../../components/page-headers/page-headers';

const { Search } = Input;

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT + '/ticket/imprimir.php';

const FormCobroConceptoComponent = ({ record }) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const isLoading = useSelector(state => state.responseReducer.loading);
    const catalogoFormasPago = useSelector(state => state.CatalogosReducer.formasPago);
    const [form] = Form.useForm();

    useEffect(() => {
        console.log('record: ', record);
        form.setFieldsValue({
            idCompra: record.id,
            idPaciente: record.idPaciente,
        })

    }, [])

    const handleSubmit = async values => {
        console.log('handleSubmit.values: ', values);
        const monto = values.monto;
        if (monto == '' || isNaN(monto) || parseInt(monto) <= 0) {
            notification.error({
                message: 'Introduce una cantidad válida',
            });
            return
        }
        const responseApi = await dispatch(pacientePagoCompraAction(values));
        if (responseApi) {
            notification.success({
                message: 'Cobro realizado correctamente',
            });
            const urlTicket = API_ENDPOINT + '?pagoId=' + responseApi.pagoId; 
            window.open(urlTicket,'','width=800,height=600')
            window.location.reload(false);
        } else {
            notification.error({
                message: 'Error al procesar el pago',
            });
        }
    };

    return (
        <Card style={{ backgroundColor: '#f9edf9' }}>

            <Form name="form_in_table" onFinish={handleSubmit} form={form}>
                <Row gutter={24}>
                    <Col span={10}>
                        <Form.Item name="idFormaPago" label="Forma de pago" rules={[{ required: true, message: 'Campo obligatorio' }]}>
                            <Select placeholder="Selecciona..." options={catalogoFormasPago} notFoundContent={'Sin registros'} />
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item
                            name="monto"
                            label="Monto recibido"
                            rules={[{ required: true, message: 'Campo obligatorio' }]}
                        >
                            <Input placeholder="" />
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Button htmlType="Save" type="success">
                            Cobrar
                        </Button>{' '}
                        <Button htmlType="Save" type="success">
                            Otorgar descuento
                        </Button>
                    </Col>
                </Row>

                <Form.Item name="idCompra" noStyle>
                    <Input hidden />
                </Form.Item>
                <Form.Item name="idPaciente" noStyle>
                    <Input hidden />
                </Form.Item>
                <Form.Item name="action" hidden initialValue='create-pago' noStyle>
                    <Input />
                </Form.Item>

            </Form>

        </Card>
    );
};

export default FormCobroConceptoComponent;
